import { QuoteState, initialQuoteState } from "./quote/quote.state";
import { QuoteCreateState, initialQuoteCreateState } from "./quote-create/quote/quote-create.state";
import { QuoteSubscriptionCreateState, initialQuoteSubscriptionCreateState } from "./quote-create/quote-subscription/quote-subscription-create.state";
import { CustomerState, initialCustomerState } from "./customer/customer.state";
import { ContactState, initialContactState } from "./contact/contact.state";
import { ContractState, initialContractState } from "./contract/contract.state";
import { CatalogState, initialCatalogState } from "./catalog/catalog.state";
import { VendorState, initialVendorState } from "./vendor/vendor.state";
import { SalesOrderState, initialSalesOrderState } from "./sales-order/sales-order.state";
import { CentralSupportState, initialCentralSupportState } from "./admin/central-support/central-support.state";
import { DeveloperState, initialDeveloperState } from "./admin/developer/developer.state";
import { SuperUserState, initialSuperUserState } from "./admin/super-user/super-user.state";
import { ContractAdminState, initialContractAdminState } from "./admin/contract-admin/contract-admin.state";

// **************************************************************************
// PAGES STORE
// Consolidated store for all page-level state (Quote, Customer, Contract, etc.)
// **************************************************************************

export interface PagesStore {
    quote: QuoteState;
    quoteCreate: QuoteCreateState;
    quoteSubscriptionCreate: QuoteSubscriptionCreateState;
    customer: CustomerState;
    contact: ContactState;
    contract: ContractState;
    catalog: CatalogState;
    vendor: VendorState;
    salesOrder: SalesOrderState;
    centralSupport: CentralSupportState;
    developer: DeveloperState;
    superUser: SuperUserState;
    contractAdmin: ContractAdminState;
}

export const initialPagesStore: PagesStore = {
    quote: initialQuoteState,
    quoteCreate: initialQuoteCreateState,
    quoteSubscriptionCreate: initialQuoteSubscriptionCreateState,
    customer: initialCustomerState,
    contact: initialContactState,
    contract: initialContractState,
    catalog: initialCatalogState,
    vendor: initialVendorState,
    salesOrder: initialSalesOrderState,
    centralSupport: initialCentralSupportState,
    developer: initialDeveloperState,
    superUser: initialSuperUserState,
    contractAdmin: initialContractAdminState,
};
